import { CountryFlag, IconSizes } from '@dixa/lib-shared-habla';
import { getCountryCodeFromPhoneNumber } from 'lib-shared-phone-numbers';

import styles from './phoneNumberCountryFlag.module.scss';

type PhoneNumberCountryFlagProps = {
  /** The phone number string value in e164 format. */
  phoneNumber?: string;
  /** The size of the flag. */
  size?: IconSizes;
};

/** A component that returns the country flag corresponding to a phone number. */
export const PhoneNumberCountryFlag = ({
  phoneNumber,
  size = 20,
}: PhoneNumberCountryFlagProps): JSX.Element => {
  const countryCode = phoneNumber
    ? getCountryCodeFromPhoneNumber(phoneNumber)
    : undefined;

  return (
    <CountryFlag
      className={countryCode ? undefined : styles.transparent}
      countryCode={countryCode ?? 'dk'}
      size={size}
    />
  );
};
